export default __webpack_public_path__ + "static/media/cont_item_01_2022.87f47890.svg";